// extracted by mini-css-extract-plugin
module.exports = {"container":"cookie-policy-section_container__Vfogo","title":"cookie-policy-section_title__l15Yi"};